"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Notifications = require("./Notifications");
Object.keys(_Notifications).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Notifications[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Notifications[key];
    }
  });
});